import type { TContactParam } from '@cian/newbuilding-chat-component';
import { useSelector } from 'react-redux';

import { getBuilderChatContact, getBuilderChatGaLabel } from '../../selectors/builderChat';

interface IParams {
  isChatOpened: boolean;
}

export const useBuilderChatUrl = ({ isChatOpened }: IParams): string | undefined => {
  const chatContact = useSelector(getBuilderChatContact);
  const gaLabel = useSelector(getBuilderChatGaLabel);

  if (!isChatOpened) {
    return undefined;
  }

  const {
    realtyUserId,
    chat: { defaultMessage, entityId, context },
  } = chatContact as TContactParam;

  return (
    `/dialogs/?hostType=frame&entityId=${entityId}&entityType=newbuilding&receiverUserId=${realtyUserId}` +
    `${context ? '&context=' + encodeURIComponent(window.btoa(JSON.stringify(context))) : ''}` +
    `${defaultMessage ? '&defaultMessage=' + encodeURIComponent(defaultMessage) : /* istanbul ignore next */ ''}` +
    `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : /* istanbul ignore next */ ''}` +
    '&noDefaultMsgIfChatExists=1' +
    '&pageType=ListingJK'
  );
};
